import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { DELETE_DMX_CONTROLLER } from './actionTypes';
import { deleteDmxControllerSuccessful, deleteDmxControllerFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* deleteController({ payload: { controller } }) {
  try {
    const response = yield call(dmxAPI.deleteController, controller.token, controller.id);
    if (response.message) {
      yield put(deleteDmxControllerSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(deleteDmxControllerFailed(error));
  }
}

export function* watchDeleteDmxController() {
  yield takeEvery(DELETE_DMX_CONTROLLER, deleteController);
}

function* deleteDmxControllerSaga() {
  yield all([fork(watchDeleteDmxController)]);
}

export default deleteDmxControllerSaga;
